import { onlineT } from "../../../typings/online";
import { paymentT } from "../../../typings/payment";
import { DialogFormController } from "../../../shared/dialog/dialog-form.controller";
import { Events } from "../../../thor.enums";

export class UpdateLinkPaymentDialogController extends DialogFormController {
    public static $inject: string[] = [
        "$log",
        "$mdDialog",
        "$mdMedia",
        "$rootScope",
        "$translate",
        "linkPaymentService",
        "toaster"
    ];

    // binded
    public containerId: number;
    public items: onlineT.Item[];
    public lastBidder: onlineT.LastBidder;
    public linkPaymentId: number;
    public linkPaymentType: paymentT.thor.LinkPaymentStateType;
    public linkPaymentExpired: boolean;

    private $t;

    constructor(
        private $log: ng.ILogService,
        $mdDialog: ng.material.IDialogService,
        $mdMedia: ng.material.IMedia,
        private $rootScope: ng.IRootScopeService,
        $translate: ng.translate.ITranslateService,
        private linkPaymentService: any,
        toaster: any
    ) {
        super($mdDialog, $mdMedia, toaster);
        this.$t = $translate.instant;
    }

    public $onInit() {
        this.partial = "update";
        this.title = this.$t(
            this.isLinkItem() ? "update_link_payment_dialog.title.item" : "update_link_payment_dialog.title.delivery"
        );
        this.submitLabel = "relancer";
    }

    public onSubmit() {
        this.preventSubmit = true;

        this.linkPaymentService
            .update(this.containerId, this.linkPaymentId, { linkPaymentExpired: this.linkPaymentExpired })
            .then(() => {
                this.$rootScope.$emit(Events.OnlineSalePaymentsUpdated);

                this.$mdDialog.hide();

                this.toaster.show(
                    this.$t(
                        this.isLinkItem()
                            ? "update_link_payment_dialog.success.item"
                            : "update_link_payment_dialog.success.delivery"
                    )
                );
            })
            .catch((error: any) => {
                this.$log.error("Unable to update link payment : ", error);

                this.$mdDialog.hide();

                this.toaster.show(this.$t("update_link_payment_alert.error"), true);
            });
    }

    private isLinkItem() {
        return this.linkPaymentType === paymentT.thor.LinkPaymentStateType.ITEM;
    }
}
